<template>
  <div class="pa-3">
    <loader v-show="$wait.is('getScientificFields')"></loader>
    <v-container v-show="!$wait.is('getScientificFields')">
      <div class="d-flex flex-column">
        <div style="width: 100%" :class="hasAdminRights && getDeviceType === 'touch' ? 'd-flex justify-space-between' : ''">
        <span class="headline font-weight-light"> Znanstvena područja </span>
      </div>
      <div
          class="d-flex justify-space-between pt-3"
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
        >
          <div
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'min-width: 400px; max-width: 800px'
                : 'width:100%'
            "
          >
          <v-text-field
            dense
            label="Traži"
            outlined
            v-model="search"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
         </div></div></div>
      <v-treeview
        dense
        style="
          border-left: 1px solid rgb(230, 230, 230);
          border-right: 1px solid rgb(230, 230, 230);
          border-bottom: 3px solid rgb(230, 230, 230);
        "
        hoverable
        :items="znanstvenaPodručja"
        off-icon="mdi-toggle-switch-off"
      >
        <template v-slot:label="{ item }">
          <v-card class="pt-0 pb-0" color="transparent" tile elevation="0">
            <v-card-title
              style="
                font-weight: normal;
                font-size: 0.875rem;
                font-family: Roboto, sans-serif;
              "
              class="pt-2 pb-2"
            >
              {{ item.naziv[0] + item.naziv.slice(1).toLowerCase() }}
              <v-spacer></v-spacer>
            </v-card-title>
          </v-card>
          <v-divider></v-divider>
        </template>
      </v-treeview>
    </v-container>
  </div>
</template>

<script>
import { waitFor } from "vue-wait";
import { mapGetters } from "vuex";
export default {
  metaInfo: {
    title: "Znanstvena područja  - Registar radova",
  },
  computed: {
    ...mapGetters(["getScientificFields"]),
    selection() {
      let arr = [];
      this.newZnanPodr?.children.forEach((podr) => {
        arr.push(podr);
      });
      return arr;
    },
    znanstvenaPodručja() {
      let podrucja = [];
      if (this.search != "") {
        this.getScientificFields.forEach((znanPodr) => {
          if (znanPodr.naziv.includes(this.search.toUpperCase())) {
            if (!podrucja.includes(znanPodr)) {
              podrucja.push(znanPodr);
            }
          }
          znanPodr.children.forEach((podPodr) => {
            if (podPodr.naziv.includes(this.search.toUpperCase())) {
              if (!podrucja.includes(znanPodr)) {
                podrucja.push(znanPodr);
              }
            }
            podPodr.children.forEach((podr) => {
              if (podr.naziv.includes(this.search.toUpperCase())) {
                if (!podrucja.includes(znanPodr)) {
                  podrucja.push(znanPodr);
                }
              }
            });
          });
        });
        return podrucja;
      } else {
        return this.getScientificFields;
      }
    },
  },
  data() {
    return {
      expanded: [],
      search: "",
      singleExpand: false,
      showBranchForm: false,
      showBranch: false,
      selectedChild: {},
      newChild: {
        name: "",
        code: "",
      },
      Branch: {
        name: "",
        code: "",
      },
      newZnanPodr: {
        id: 7575757,
        name: "",
        code: "",
        children: [],
      },
      showForm: false,
      switch1: false,
      headers: [
        {
          text: "Područje",
          align: "start",
          sortable: false,
          value: "name",
        },
      ],
      actions: [{ title: "Uredi" }, { title: "Izbriši" }],
    };
  },
  beforeMount() {
    waitFor("getScientificFields", async function () {
      await this.$store.dispatch("getScientificFields");
    }).apply(this);
  },
};
</script>
<style lang="css">
.v-treeview-node {
  /* background-color: rgba(15, 15, 186, 0.308); */
}
</style>
